// extracted by mini-css-extract-plugin
export default {"trainingContainer":"training_trainingContainer__a67JS","content":"training_content__ttSvI"};